import { useCallback, useState } from 'react'
import { stackData } from './useDataLoaderUtils/stack'
import { transposeDataset } from '../services/dataTransforms'

export default function useDataTransforms({
  userData,
  setUserData,
  data,
  parseDatasetAndSetData,
  locale,
  decimalsSeparator,
  thousandsSeparator,
}) {
  const [stackDimension, setStackDimension] = useState()
  const [unstackedInfo, setUnstackedInfo] = useState([null, null])
  const [unstackedData, unstackedColumns] = unstackedInfo

  const handleStackOperation = useCallback(
    (column) => {
      setStackDimension(column)
      if (column !== null) {
        if (unstackedData === null) {
          setUnstackedInfo([userData, data.dataTypes])
        }
        const stackedData = stackData(unstackedData || userData, column)
        setUserData(stackedData)
        parseDatasetAndSetData(stackedData, undefined, {
          locale,
          decimal: decimalsSeparator,
          group: thousandsSeparator,
        })
      } else {
        setUserData(unstackedData)
        parseDatasetAndSetData(unstackedData, unstackedColumns, {
          locale,
          decimal: decimalsSeparator,
          group: thousandsSeparator,
        })
        setUnstackedInfo([null, null])
      }
    },
    [
      unstackedData,
      unstackedColumns,
      userData,
      setUserData,
      data,
      parseDatasetAndSetData,
      locale,
      decimalsSeparator,
      thousandsSeparator,
    ]
  )

  const handleTranspose = useCallback(() => {
    if (!userData || userData.length === 0) return
    const transposedData = transposeDataset(userData)
    setStackDimension(null)
    setUnstackedInfo([null, null])
    setUserData(transposedData)
    parseDatasetAndSetData(transposedData, undefined, {
      locale,
      decimal: decimalsSeparator,
      group: thousandsSeparator,
    })
  }, [userData, setUserData, parseDatasetAndSetData, locale, decimalsSeparator, thousandsSeparator])

  return {
    stackDimension,
    setStackDimension,
    unstackedData,
    unstackedColumns,
    setUnstackedInfo,
    handleStackOperation,
    handleTranspose,
  }
}
